import { render } from "./designSwitchPrint.vue?vue&type=template&id=59dda072"
import script from "./designSwitchPrint.vue?vue&type=script&lang=js"
export * from "./designSwitchPrint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__